import { useEffect } from 'react';
import { useRecentlyViewedStorageAPI } from './useRecentlyViewedStorageAPI';
import { isBadOrEmptyString } from '../../../predicates/string';
import { removeQueryParam } from '../../../utils/url';
import { isNull } from '../../../predicates/type';

export const useRecentlyViewedRemoveQueryParamsMigration = ({
	queryParamsToRemove,
}: {
	queryParamsToRemove: string[];
}) => {
	const { setStoredRecentDetailPagesByListPageTypeId, getAllStoredRecentDetailPages } = useRecentlyViewedStorageAPI();
	const normalizedQueryParamsToRemove = queryParamsToRemove.map((param) => param.toLowerCase());

	useEffect(() => {
		const allStoredItems = getAllStoredRecentDetailPages();

		if (isNull(allStoredItems)) {
			return;
		}

		for (const listPageTypeId in allStoredItems) {
			const detailPageItems = allStoredItems[listPageTypeId].map((item) => {
				const { detailPageUrl } = item;

				if (isBadOrEmptyString(detailPageUrl)) {
					return item;
				}

				const existingQueryParams = normalizedQueryParamsToRemove.filter((param) =>
					detailPageUrl.toLowerCase().includes(param),
				);

				if (existingQueryParams.length === 0) {
					return item;
				}

				let newDetailPageUrl = detailPageUrl;

				existingQueryParams.forEach((param) => {
					newDetailPageUrl = removeQueryParam(newDetailPageUrl, param);
				});

				return {
					...item,
					detailPageUrl: newDetailPageUrl,
				};
			});

			setStoredRecentDetailPagesByListPageTypeId(listPageTypeId, detailPageItems);
		}
	}, [getAllStoredRecentDetailPages, normalizedQueryParamsToRemove, setStoredRecentDetailPagesByListPageTypeId]);
};
